<template>
    <customer-representative 
      v-if="demandTypeName == 'representative-address-update'"
      :validation-request-id="demand.id"
      :is-details="true"
    ></customer-representative>

    <customer-update 
      v-else-if="demandTypeName == 'customer-update'"
      :validation-request-id="demand.id"
      :is-details="true"
    ></customer-update>

    <customer-creation 
      v-else-if="demandTypeName == 'representative-creation'"
      :validation-request-id="demand.id"
      :is-details="true"
    ></customer-creation>

    <mail-forward 
      v-else-if="demandTypeName == 'mail-forward-address-creation' || demandTypeName == 'mail-forward-address-update'"
      :validation-request-id="demand.id"
      :is-details="true"
    ></mail-forward>

    <representative 
      v-else-if="demandTypeName == 'representative-mainification' || demandTypeName == 'representative-unmainification' || demandTypeName == 'representative-person-update' || demandTypeName == 'representative-termination'"
      :validation-request-id="demand.id"
      :is-details="true"
    ></representative>

    <customer-address-update 
      v-else-if="demandTypeName == 'customer-address-update' || demandTypeName =='customer-address-creation'"
      :validation-request-id="demand.id"
      :is-details="true"
    ></customer-address-update>

    <domiciliation-contract-validation 
      v-else-if="['domiciliation-contract-validation', 'office-contract-validation'].includes(demandTypeName)"
      :validation-request-id="demand.id" 
      :is-details="true"
    ></domiciliation-contract-validation>
</template>

<script>
import CustomerRepresentative from "components/Demands/Details/CustomerRepresentative"
import CustomerUpdate from "components/Demands/Details/CustomerUpdate"
import CustomerCreation from "components/Demands/Details/CustomerCreation"
import CustomerAddressUpdate from "components/Demands/Details/CustomerAddressUpdate"
import DomiciliationContractValidation from "components/Demands/Details/DomiciliationContractValidation"
import MailForward from "components/Demands/Details/MailForward"
import Representative from "components/Demands/Details/Representative"

  export default {
    name:"DemandDetails",
    props:["demand","index"],
    components: {
      CustomerRepresentative,
      CustomerAddressUpdate,
      CustomerCreation,
      MailForward,
      Representative,
      DomiciliationContractValidation,
      CustomerUpdate,
    },
    computed: {
      demandType() {
        return this.demand.included.hasOwnProperty('type') ? this.demand.included.type : null
      },
      demandTypeName() {
        return this.demandType ? this.demandType.attributes.name : null
      }
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/Demands/DemandDetails.vue